import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    periodLabel: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: '10px 0px',
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(4),
    },
  }),
);

export default useStyles;
